<div class="radio-comp">
  <label for="{{id}}">
    <span (click)="check()" class="zui-content radioButton zui-radio" [ngClass]="{'radioUnChecked': !data, 'radioChecked': data, 'disabled': disabled == true , 'disabledSelected': disabled == true && value === true}"></span>
    <input type="radio" class="zui-radio" id="{{id}}" [attr.disabled]="disabled == true ? true : false"  name="{{name}}" [checked]="value" />   
    <span class="zui-content label-text" *ngIf="label">{{label}}</span>
  </label>
</div>